export default function EnvTestPage() {
  const envVars = {
    VITE_ELECTRIC_SHAPE_URL: import.meta.env.VITE_ELECTRIC_SHAPE_URL,
    VITE_Y_UPDATE_SEND_URL: import.meta.env.VITE_Y_UPDATE_SEND_URL,
    VITE_AWARENESS_WS_URL: import.meta.env.VITE_AWARENESS_WS_URL,
    VITE_BASE_URL: import.meta.env.VITE_BASE_URL,
    VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
    VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
    MODE: import.meta.env.MODE,
    DEV: import.meta.env.DEV,
    PROD: import.meta.env.PROD,
  };

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Environment Variables Test</h1>
      <pre className="bg-gray-100 p-4 rounded">
        {JSON.stringify(envVars, null, 2)}
      </pre>
    </div>
  );
}